import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../stores/redux-store';
import { fetchProviderPaymentConditions } from '../../services/payments-services';
import { useSelectedProvider } from '../../../../components/App/ProviderContainer/useSelectedProvider';

export const useProviderPaymentConditions = () => {
  const dispatch = useDispatch();
  const { selectedProvider } = useSelectedProvider();
  const paymentConditions = useAppSelector(
    (state) => state.selectedProvider.data.paymentConditions
  );
  const paymentConditionsLoading = !paymentConditions;
  const fetchPaymentConditions = useCallback(() => {
    dispatch(fetchProviderPaymentConditions(selectedProvider.name));
  }, [dispatch, selectedProvider.name]);

  useEffect(() => {
    if (paymentConditionsLoading) {
      fetchPaymentConditions();
    }
  }, [fetchPaymentConditions, paymentConditionsLoading]);

  return paymentConditions;
};
